import { useState } from "react";
import InsertClientModal from "../modals/InsertClient";
import EditClientModal from "../modals/EditClient";
import { Page, DataTable } from "@iq/models";
import { FiPlus } from "react-icons/fi";

const CLIENT_TABLE_CONFIG = {
    columns: [
        { 
            key: "name", 
            label: "Name", 
            accessor: (row) => row?.name || row?.client_name || "-", 
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"]
        },
        { 
            key: "company", 
            label: "Company", 
            accessor: (row) => row?.company || row?.organization_name || "-", 
            filterable: false
        },
        { 
            key: "email", 
            label: "Email", 
            accessor: (row) => row?.email || "-", 
            filterable: false 
        },
        { 
            key: "phone", 
            label: "Phone", 
            accessor: (row) => row?.phone || row?.phone_number || "-", 
            filterable: false 
        },
        { 
            key: "status", 
            label: "Status", 
            accessor: (row) => row?.status || "-", 
            filterable: true,
            quickValues: ["Active", "Pending", "Inactive"]
        },
    ],
};

function Clients({ clients = [], loading = false, error = "", onClientInserted }) {
    const rows = Array.isArray(clients) ? clients : [];
    const [showInsertClientModal, setShowInsertClientModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);

    function handleCloseInsertClient() {
        setShowInsertClientModal(false);
        onClientInserted?.();
    }

    function handleRowClick(client) {
        setSelectedClient(client);
    }

    return (
        <Page>
            <div>
                <DataTable
                    rowData={rows}
                    loading={loading}
                    tableConfig={CLIENT_TABLE_CONFIG}
                    onRowClick={handleRowClick}
                />

                <button
                    type="button"
                    onClick={() => setShowInsertClientModal(true)}
                    aria-label="Insert client"
                    style={{
                        position: "absolute",
                        right: "var(--space-6)",
                        bottom: "var(--space-6)",
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "var(--color-highlight)",
                        color: "var(--color-bg-page)",
                        fontSize: "1.6rem",
                        lineHeight: 1,
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "var(--shadow-sm)",
                    }}
                >
                    <FiPlus size={24} />
                </button>
            </div>

            {showInsertClientModal ? (
                <InsertClientModal
                    onClose={() => setShowInsertClientModal(false)}
                    onInserted={handleCloseInsertClient}
                />
            ) : null}

            {selectedClient ? (
                <EditClientModal
                    client={selectedClient}
                    onClose={() => setSelectedClient(null)}
                    onInserted={() => {
                        setSelectedClient(null);
                        onClientInserted?.();
                    }}
                />
            ) : null}
        </Page>
    );
}

export default Clients;